module.exports = __webpack_public_path__ + "static/logo-white-534e09eae257a1228af1a47e7f1ca4d9.png";